import { Controller } from "@hotwired/stimulus"
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = [];

  connect() {
    this.dirtyForm = false;
    window.addEventListener('beforeunload',
      (event) => this.checkWindowUnload(event)
    );
    window.addEventListener('turbo:before-visit',
      (event)=> this.checkWindowUnload(event)
    );
  }

  disconnect() {
    window.removeEventListener('beforeunload',
      (event) => this.checkWindowUnload(event)
    );
    window.removeEventListener('turbo:before-visit',
      (event)=> this.checkWindowUnload(event)
    );
  }

  makeDirty() {
    this.dirtyForm = true;
  }

  makeClean() {
    this.dirtyForm = false;
  }

  checkDirty(event) {
    if (this.dirtyForm) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
      if (confirm('There are unsaved changes, are you sure you want to leave?')) {
        this.dirtyForm = false;
        event.target.click();
      }
    }
  }

  checkDirtyWithPrevent(event) {
    if (this.dirtyForm) {
      if (confirm('There are unsaved changes, are you sure you want to leave?')) {
        this.dirtyForm = false;
      } else {
        event.preventDefault();
      }
    }
  }

  checkWindowUnload(event) {
    if(this.dirtyForm) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
      if (confirm('There are unsaved changes, are you sure you want to leave?')) {
        this.dirtyForm = false;
        Turbo.visit(event.detail.url);
      }
    }
  }
}
